module.exports = __webpack_public_path__ + "static/media/right-arrow.9ea16574.svg";